import PropTypes from 'prop-types';
import ScheduleMemberType from './scheduleMember';

const ScheduleType = PropTypes.shape({
  members: PropTypes.arrayOf(ScheduleMemberType).isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
});

export default ScheduleType;



// WEBPACK FOOTER //
// ./client/app/shared/types/schedule.js